module.exports = "/img/item-2.ea6825db.png";